import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { GET_BLOCKS_DELIVERYMAN } from './constants';
import type { Block } from './types';
import { apiClient } from '@/_config/lib/axios/api-client';

type GetBlocksDeliverymanProps = {
  deliverymanId: string;
};

const getBlocksDeliveryman = (params: GetBlocksDeliverymanProps) => {
  const { deliverymanId } = params;
  return apiClient
    .get<Block[]>(`/entregadores/${deliverymanId}/blocks`)
    .then(response => response)
    .catch(handleResponseThrowError());
};

type GetBlocksDeliverymanData = Awaited<
  ReturnType<typeof getBlocksDeliveryman>
>;

export const useGetBlocksDeliveryman = (
  params: GetBlocksDeliverymanProps,
  options: Omit<
    UseQueryOptions<
      GetBlocksDeliverymanData,
      unknown,
      GetBlocksDeliverymanData,
      (string | GetBlocksDeliverymanProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_BLOCKS_DELIVERYMAN, params],
    queryFn: () => getBlocksDeliveryman(params),
    ...options,
  });
};
